import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  container: {
    height: '100%',
    maxHeight: '100%',
    width: '100%',
    padding: 5,
    overflow: 'auto',
  },
  icons: {
    fontSize: '20px',
    transition: '0.3s',
    margin: '3px 0 10px -16px',
  },
  badge: {
    right: '-4px',
    bottom: '14px',
    color: 'black',
  },
});
